import { BaseWebComponentRepository } from '../../../framework/BaseWebComponentRepository';
import { PackagesGridDataProviderFactory } from '../factory/PackagesGridDataProviderFactory';
import { PackagesBaseDataProvider } from '../dataProvider/PackagesBaseDataProvider';
import { Package } from '../types/packages-grid-package';
import { DeleteSelectedResponse } from '../types/packages-grid-responses';
import { PackageLinksData } from '../types';

export class PackagesRepository extends BaseWebComponentRepository {
  public dataProviderFactory: PackagesGridDataProviderFactory;
  public dataProvider: PackagesBaseDataProvider;

  constructor() {
    super();
    this.initialSetup({
      dataProviderFactory: new PackagesGridDataProviderFactory(),
    });
  }

  public async getDataForView() {
    return this.dataProvider.getDataForView();
  }

  public async getPackageLinks(packageId: string): Promise<PackageLinksData> {
    return await this.dataProvider.getPackageLinks(packageId);
  }

  public async deleteSelected(payload: { records: Array<Package> }): Promise<DeleteSelectedResponse> {
    return this.dataProvider.deleteSelectedPackages(payload);
  }
}
